import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export const fosterUnfavorite = async (fosterId: number) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.delete(
      `${apiUrl}/api/user/foster/${fosterId}/favorite`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error unfavoriting foster:", error);
    throw error;
  }
};
